import { render, staticRenderFns } from "./SubjectGroupDataTable.vue?vue&type=template&id=9cebc338&scoped=true"
import script from "./SubjectGroupDataTable.vue?vue&type=script&lang=js"
export * from "./SubjectGroupDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cebc338",
  null
  
)

export default component.exports